import { MedmalStepService } from './../../../Services/MedmalStepService';
import { PayfortTransInfoModel } from './../../../Models/ProposalModel';
import { LanguageService } from './../../../Services/languageService';
import { restURL } from './../../../Models/restURL';
import { Router } from '@angular/router';
import { MedmalBindMdl } from './../../../Models/MedmalBindMdl';
import { Subscription } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MedmalProposal, MedmalstatusMdl } from '../../../Models/MedmalProposal';
import { proposalResMdl } from '../../../Models/proposalResMdl';
import { userService } from '../../../Services/userService';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { EncryptionService } from '../../../Services/EncryptionService';
import { APIService } from '../../../Services/api.service';
import { mdlGetPayfortFieldsReq } from '../../../Models/mdlGetPayfortFieldsReq';
import { mdlStatus } from '../../../Models/CompAttachmentsMdl';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'MedmalReviewConfirm',
  templateUrl: './MedmalReviewConfirm.html',
  styleUrls: ['./MedmalReviewConfirm.css']
})
export class MedmalReviewConfirm {
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean = false;
  public LngSubscription: Subscription;
  public medmalBindObj: MedmalBindMdl = new MedmalBindMdl();
  public proposalObj: MedmalProposal = new MedmalProposal();
  public Lng: string;
  public isError: boolean;
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
  public PayfortObj:mdlGetPayfortFieldsReq=new mdlGetPayfortFieldsReq();
  public Medmalstatusobj: MedmalstatusMdl = new MedmalstatusMdl();
  public prRes: proposalResMdl = new proposalResMdl();

  public LimitofLiabilityEn: string;
  public SchemeEn: string;
  public PeriodEn: string;
  public NameofHospitalEn: string;
  public ProfessionEn: string;

  public LimitofLiabilityAr: string;
  public SchemeAr: string;
  public PeriodAr: string;
  public NameofHospitalAr: string;
  public ProfessionAr: string;
  public UniqueUploadno:string;
  public ImageURL:string;
  public showError = false;

  public AddressType: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();


  constructor(private APISer: APIService,private EncriptService: EncryptionService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private medStepService: MedmalStepService, private userinfo: userService) {
    
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.isError = false;

    // this.isError=false;
    if (sessionStorage.getItem("Language") != null) {
      let lng: any = sessionStorage.getItem("Language");
      this.Lng = lng;
    }
    else {
      this.Lng = "en";
    }
    if (sessionStorage.getItem("medmalProposalObj") != null) {
      let proposalObj: any = sessionStorage.getItem("medmalProposalObj");
      let medmalBindObj: any = sessionStorage.getItem("medmalBindObj");
      this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(proposalObj));
      this.medmalBindObj = JSON.parse(this.EncriptService.DecriptObject(medmalBindObj));

      this.getSeletedPlanInfo();
    }
    else {
      this.router.navigate(['NewDashboard/MedmalNewProposal']);
    }
    let UseriD:any=sessionStorage.getItem("UserId")
    this.medmalBindObj.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
    this.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
    
    this.GetAttachmentUniqueuploadNo();

    this.validateAttachment2();
    this.validateAttachment3();

  }

  getSeletedPlanInfo() {

    this.LimitofLiabilityEn = this.medmalBindObj.indemnityList.filter(t => t.IndemnityCode == this.proposalObj.IndemnityCode)[0].IndemnityDescEn;
    this.LimitofLiabilityAr = this.medmalBindObj.indemnityList.filter(t => t.IndemnityCode == this.proposalObj.IndemnityCode)[0].IndemnityDescAr;

    this.SchemeEn = this.medmalBindObj.schemeList.filter(t => t.SchemeCode == this.proposalObj.SchemeCode)[0].SchemeDesc;
    this.SchemeAr = this.medmalBindObj.schemeList.filter(t => t.SchemeCode == this.proposalObj.SchemeCode)[0].SchemeDesc_Ar;

    this.NameofHospitalEn = this.medmalBindObj.hospList.filter(t => t.HospitalCode == this.proposalObj.Insured_HospId)[0].HospitalNameEn;
    this.NameofHospitalAr = this.medmalBindObj.hospList.filter(t => t.HospitalCode == this.proposalObj.Insured_HospId)[0].HospitalNameAr;

    this.ProfessionEn = this.medmalBindObj.professionList.filter(t => t.ProfessionCode == this.proposalObj.Insured_Professioncode)[0].ProfessionDesc_Eng;
    this.ProfessionAr = this.medmalBindObj.professionList.filter(t => t.ProfessionCode == this.proposalObj.Insured_Professioncode)[0].ProfessionDesc_Ar;

  }

  goPrev() {
    this.router.navigate(['NewDashboard/MedmalInsuredInfo']);
  }

  goNext() {
    this.saveProposal();
  }
  async GetAttachmentUniqueuploadNo() {
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/GetAttachmentUniqueuploadNo", this.proposalObj.UserID)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    this.UniqueUploadno= APIRes[1];

  }

  // async ValidateIBAN() {
  //   this.isShowLoading = true;
  //   var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/ValidateMedmalIBAN", this.proposalObj)
  //   this.isShowLoading = false;
  //   var APIStatus = APIRes[0]
  //   if (APIStatus.StatusCode == "F") {
  //     Swal(APIStatus.StatusDesc, "", "error")
  //     return;
  //   }
  //   this.Medmalstatusobj = APIRes[1];

  //   if (this.Medmalstatusobj.StatusCode == "F") {
  //     this.Lng == "en" ? Swal(this.Medmalstatusobj.StatusDescEn) : Swal(this.Medmalstatusobj.StatusDescAr);

  //   }
  //   else {
  //     this.saveProposal();
  //   }

  // }


  async saveProposal() {
    this.showError=true;
    this.validateAttachment2();
    this.validateAttachment3();;
    if(this.proposalObj.Attachment2==""||this.proposalObj.Attachment2==null)return;
    if(this.proposalObj.Attachment3==""||this.proposalObj.Attachment3==null)return;

    this.isShowLoading = true;

    this.proposalObj.PortalRegNo = sessionStorage.getItem("RegNo");
 
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/SaveProposal", this.proposalObj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let objResObj: PayfortTransInfoModel = new PayfortTransInfoModel();
    objResObj = APIRes[1];
    // if (objResObj.RegNo != this.proposalObj.PortalRegNo) {
    //       Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
    //       this.router.navigate(['BeforeLogin/NewReg']);
    //       return;
    //     }
    this.transObj = objResObj;
    this.PayfortObj.ProposalNo=this.transObj.ProposalNo
    this.PayfortObj.InsuredIdNo=this.proposalObj.Insured_IDNo
    this.PayfortObj.InsuredName=this.transObj.InsuredName
    this.PayfortObj.TotalPremium=this.transObj.Premium
    this.PayfortObj.ProductCode=this.transObj.ProductCode
    this.PayfortObj.PaySign=this.transObj.EPayInfo
    this.PayfortObj.UserId=this.proposalObj.UserID



    if (this.transObj.st.StatusCode == "F") {
      this.isError = true;
      this.isShowLoading = false;
      this.Lng == "en" ? Swal(this.transObj.st.StatusDesc) : Swal(this.transObj.st.StatusDescAr);

    }
    else {
      this.isError = false;
      this.isShowLoading = false;
      if (this.transObj.isUnderwriter == true) {
        this.Lng == "en" ? Swal(`Application Sent for Underwriter and your Proposal Number is ${this.transObj.ProposalNo}`,"","info") : Swal(`${this.transObj.ProposalNo} تم إرسال الطلب للمتعهد ورقم عرضك هو`,"","info");
        sessionStorage.setItem("NavFrom", "PR");
        //sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
        sessionStorage.setItem("CurrentRoute", "Dashboard");
        this.router.navigate(['/Menu/Dashboard']);
      } else {
        this.Lng == "en" ? Swal(this.transObj.st.StatusDesc,"","success") : Swal(this.transObj.st.StatusDescAr,"","success");
        sessionStorage.setItem("NavFrom", "PR");
        // sessionStorage.setItem("PaymentObj", this.EncriptService.EncriptObject(JSON.stringify(this.PayfortObj)));
        sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
        this.router.navigate(['/NewDashboard/PayfortPayment']);
      }
    }
  }

  OnSelectChooseFile(event: any,Attachment: any, type: any, uploadType: any) {

    

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG" && fileExt.toString().toUpperCase() != "PDF") {
        Swal("","Please select valid image", "error");
        return;
      }
      var isvalid = "";
      if (fsize > 2) {
        Swal("", "File Size Should not exceed 2 MB", "error");
        return;
      }
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let base64long = target.result;
          // this.base64 = base64.split(",")[1];
          this.CreateFormDataAndUpload(base64long, `${type}`, `.${fileExt}`, Attachment, uploadType)
        }
      }
      event.target.files = null;
      event.target.value = null;

    }

  }

  CreateFormDataAndUpload(base64: any, filetype: any, FileExt: any, Attachment: any, uploadType: any) {
    //extract base64 without data:type
    this.isShowLoading = true;
    const base64WithoutDataType = base64.split(",")[1];
    //base64 to file
    let byteCharacters = atob(base64WithoutDataType);
    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++)
      byteNumbers[i] = byteCharacters.charCodeAt(i);

    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { type: "image/jpg" });
    const fileToBeUploaded = new File([blob], FileExt);

    var fd = new FormData();
    fd.append("attchmentId", this.UniqueUploadno + "_" + Attachment)
    fd.append("fileType", filetype);
    fd.append("file", fileToBeUploaded);
    fd.append("FileName", `Medmal_${this.UniqueUploadno }_${Attachment}${FileExt}`);
    this.uploadFile(fd, filetype, Attachment, base64WithoutDataType, FileExt, uploadType);
  }

  async uploadFile(fd: FormData, filetype: string, Attachment: any, base64: any, FileExt: any, uploadType: any) {
    var param = environment;              
    if (!param.St.StatusDesc) {
        throw new Error("Encryption key is not initialized.");
    }

    var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
    var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));
        
    this.isShowLoading = true;
    let httpOptions: any;
    var header: HttpHeaders = new HttpHeaders();
    header.delete('Content-Type');
    header.set('enctype', "multipart/form-data");
    header = header.append('Accept-Encoding', 'gzip');
    header = header.append('apiToken', "");
    header = header.append("Authorization", "Basic " + btoa(UserName + ':' + Password));
    httpOptions = { headers: header };


    type NewType = mdlStatus;

    await this.http.post<NewType>(this.url.baseURL + "Upload/SaveAttachmentsCentralizedMedmal", fd, httpOptions).toPromise().then(
      async (res: any) => {
        if (res.StatusCode != "S") {
          Swal("",`${Attachment} ${filetype} Image Upload Failed ${res.StatusDesc}`, "error")
        }
        else {

          if (uploadType == "Qualification") {
            this.proposalObj.Attachment1 = `Medmal_${this.UniqueUploadno}_${Attachment}${FileExt}`;
            
          }
          if (uploadType == "LicensedCopy") {
            this.proposalObj.Attachment2 = `Medmal_${this.UniqueUploadno}_${Attachment}${FileExt}`;
            
          }
          if (uploadType == "CustomerId") {
            this.proposalObj.Attachment3 = `Medmal_${this.UniqueUploadno}_${Attachment}${FileExt}`;
          
        }
        if (uploadType == "ProposalForm") {
          this.proposalObj.Attachment4 = `Medmal_${this.UniqueUploadno}_${Attachment}${FileExt}`;
        
      }

        }
      },
      (error) => {
        Swal("",`${filetype} Image Upload Failed: ` + error.message, "error")
      });
      this.isShowLoading = false;
  }

  ViewImage(filename: any) {
    this.ImageURL = this.url.AttachemntsMedmalURL + filename;
    // this.Preview = true;
    window.open(this.ImageURL, "_blank");
  }

  validateAttachment1() {
    if (!this.proposalObj.Attachment1) {
      return "required"
    }
    return "";
  }
  validateAttachment2() {
    if (!this.proposalObj.Attachment2) {
      return "required"
    }
    return "";
  }
  validateAttachment3() {
    if (!this.proposalObj.Attachment3) {
      return "required"
    }
    return "";
  }
  validateAttachment4() {
    if (!this.proposalObj.Attachment4) {
      return "required"
    }
    return "";
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalReviewConfirm/MedmalReviewConfirm.ts